export const SeasonStatus=Object.freeze({
    ACTIVE:"ACTIVE",
    REGISTRATION_OPENED:"REGISTRATION_OPENED",
    REGISTRATION_CLOSED:"REGISTRATION_CLOSED",
    DISABLED:"DISABLED"
})

export const seasonStatusLabel = (status) => {
    switch (String(status || "").toUpperCase()) {
        case SeasonStatus.ACTIVE:
            return "Draft";
        case SeasonStatus.REGISTRATION_OPENED:
            return "Open";
        case SeasonStatus.REGISTRATION_CLOSED:
            return "Closed";
        case SeasonStatus.DISABLED:
            return "Disabled";
        default:
            return status || "Draft";
    }
};

export const sortEventsRecentFirst = (events = []) =>
    [...events].sort((left, right) => {
        const leftDate = new Date(left.startDate || left.eventDate || 0).getTime();
        const rightDate = new Date(right.startDate || right.eventDate || 0).getTime();
        return rightDate - leftDate;
    });